export type SettingsGlobalState = {
  isOpenPatientPageAfterCreation: boolean;
  isOpenVisitAfterCreation: boolean;
  isNightTheme: boolean;
  resourceTypesWithEnabledAnyAvailable: string[];
};

export const defaultSettingsGlobalState: SettingsGlobalState = {
  isOpenPatientPageAfterCreation: false,
  isOpenVisitAfterCreation: false,
  isNightTheme: false,
  resourceTypesWithEnabledAnyAvailable: [],
};
